<template>
  <div class="chatbot-management-container" v-rect-loading="loading">
    <iframe :src="chatbotUrl" frameborder="0" scrolling="yes" class="iframe-container" ref="iframe"></iframe>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      chatbotUrl: ''
    }
  },
  created () {
    this.initData()
  },
  computed: {
  },
  methods: {
    ...mapActions('chatbot', ['chatbotManagementInfo']),
    async initData () {
      this.loading = true
      try {
        const resp = await this.chatbotManagementInfo()
        if (resp && resp.chatbot_url) {
          this.chatbotUrl = resp.chatbot_url
        }
      } finally {
        this.loading = false
      }
    },
    onI18nChange () {
      const iframe = this.$refs.iframe
      iframe.contentWindow?.postMessage({
        i18nLocale: this.$i18n.locale
      }, this.chatbotUrl)
    }
  },
  watch: {
    '$i18n.locale': {
      handler () {
        this.onI18nChange()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.chatbot-management-container {
  width: 100%;
  height: 100%;

  .iframe-container {
    width: 100%;
    height: 100%;
  }
}
</style>>
